import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import Field from "../../../components/Fields/Field";
import FieldLabel from "../../../components/Fields/FieldLabel";
import NumberField from "../../../components/Fields/NumberField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import SizeModel from "../../../models/SizeModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

const AddSizePopup: React.FC<PopupProps> = ({ show, onHide }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<SizeModel>();

    const sizesets = useSelectListOptions('api/v1/selectlist/Sizesets?activeOnly=true', '-- Select sizeset');

    useEffect(() => {
        setFormData({
            id: 0,
            sizeSetId: 0,
            name: '',
            beginDate: new FormatUtils().formatDateForStorage(new Date()),
            endDate: '',
            concurrencyId: ''
        } as SizeModel);
    }, [])

    function submit() {
        if (formData) {
            DataService
                .create<SizeModel>(`api/v1/Sizes`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'sortOrder', label: 'Sort order' },
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getLabelProps, getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Size'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('sizeSetId')} options={sizesets} />
                <TextboxField {...getFieldProps('name')} />
                <NumberField {...getFieldProps('sortOrder')} />
                <Field {...getLabelProps('beginDate')}>
                    <DateControl {...getControlProps('beginDate')} />
                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                    <DateControl {...getControlProps('endDate')} />
                </Field>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddSizePopup;